(function(){
  /* =========================================
    BP Finder locale-safe URL handling
    - Uses window.bpFinderLocaleRoot if set in Liquid
    - Falls back to Shopify.routes.root
    - Falls back to /
  ========================================== */

  function bpGetLocaleRoot(){
    var root = "/";

    try{
      if(window.bpFinderLocaleRoot){
        root = window.bpFinderLocaleRoot;
      }else if(window.Shopify && Shopify.routes && Shopify.routes.root){
        root = Shopify.routes.root;
      }
    }catch(e){}

    if(!root) root = "/";
    if(root.slice(-1) !== "/") root = root + "/";

    return root;
  }

  function bpGetLang(){
    var lang = "en";

    try{
      if(window.bpFinderLocaleCode){
        lang = String(window.bpFinderLocaleCode).slice(0, 2).toLowerCase();
      }else if(document.documentElement.lang){
        lang = String(document.documentElement.lang).slice(0, 2).toLowerCase();
      }else{
        var path = window.location.pathname || "";
        if(path.indexOf("/fr") === 0) lang = "fr";
        if(path.indexOf("/es") === 0) lang = "es";
        if(path.indexOf("/de") === 0) lang = "de";
      }
    }catch(e){}

    if(["fr", "es", "de"].indexOf(lang) === -1) lang = "en";
    return lang;
  }

  function bpStripOwnOrigin(url){
    if(!url) return "";

    try{
      if(url.indexOf("http://") === 0 || url.indexOf("https://") === 0){
        var parsed = new URL(url, window.location.origin);
        if(parsed.hostname === window.location.hostname || parsed.hostname === "billingtonpix.com" || parsed.hostname === "www.billingtonpix.com"){
          return parsed.pathname + parsed.search + parsed.hash;
        }
        return url;
      }
    }catch(e){}

    return url;
  }

  function bpLocalizePath(path){
    if(!path) return "#";

    path = String(path);

    if(
      path.indexOf("#") === 0 ||
      path.indexOf("mailto:") === 0 ||
      path.indexOf("tel:") === 0 ||
      path.indexOf("javascript:") === 0 ||
      path.indexOf("//") === 0
    ){
      return path;
    }

    path = bpStripOwnOrigin(path);

    if(path.indexOf("http://") === 0 || path.indexOf("https://") === 0){
      return path;
    }

    var localeRoot = bpGetLocaleRoot();

    if(localeRoot === "/"){
      return path.charAt(0) === "/" ? path : "/" + path;
    }

    var localePrefix = localeRoot.replace(/\/$/, "");

    if(path.indexOf(localePrefix + "/") === 0){
      return path;
    }

    path = path.replace(/^\/+/, "");

    return localeRoot + path;
  }

  var LANG = bpGetLang();

  var I18N = {
    en: {
      routeNames: {
        gym: "Gym Leggings",
        pro: "Pro Wrestling Tights",
        fashion: "Fashion Meggings",
        bundles: "Matching Sets"
      },
      feelNames: {
        compression: "Firm Compression",
        balanced: "Balanced Fit",
        relaxed: "Relaxed Feel"
      },
      energyNames: {
        classic: "Classic and Bold",
        neon: "Neon and Expressive",
        retro: "Retro 80s",
        dark: "Dark and Graphic",
        clean: "Clean and Minimal"
      },
      boldNames: {
        low: "Low-key",
        mid: "Noticeable",
        high: "Statement"
      },
      why: {
        gym: "You are training first, so start with pieces built for movement, comfort, and durability - then choose the look you like inside the collection.",
        pro: "You want a performance-level look with presence. Start with styles designed to move well and stand out in high-energy settings.",
        fashion: "You are wearing leggings as part of your outfit. Start with styling-forward designs made to look sharp beyond the gym.",
        bundles: "You want a coordinated outfit with zero guesswork. Start with matching sets designed to work together visually."
      },
      buttons: {
        shop: "Shop this collection",
        alt: "Explore an alternative",
        direction: "Try a different direction",
        joggers: "Try joggers instead"
      },
      footerBundle: "Prefer a single piece instead? You can browse Pro Wrestling Tights or Fashion Meggings.",
      picksTitle: "Top picks for your style",
      basedOn: "Based on your picks: ",
      energyWord: " energy, ",
      impactWord: " impact.",
      picksSub: "These picks balance style and comfort based on how you want to move and be seen.",
      loose: "Prefer something looser?",
      fullOutfit: "Want a full outfit?",
      from: "From ",
      tap: "Tap to view",
      view: "View ",
      joggersFallback: "Looser fit alternative",
      bundleFallback: "Joggers and bomber jacket",
      badges: {
        gym: "GYM PERFORMANCE",
        wrestling: "PRO WRESTLING STYLE",
        meggings: "FASHION MEGGINGS"
      }
    },

    fr: {
      routeNames: {
        gym: "Leggings de sport",
        pro: "Collants de catch",
        fashion: "Meggings de mode",
        bundles: "Ensembles assortis"
      },
      feelNames: {
        compression: "Compression ferme",
        balanced: "Coupe équilibrée",
        relaxed: "Sensation plus décontractée"
      },
      energyNames: {
        classic: "Classique et audacieux",
        neon: "Néon et expressif",
        retro: "Rétro 80s",
        dark: "Sombre et graphique",
        clean: "Net et minimal"
      },
      boldNames: {
        low: "Discret",
        mid: "Visible",
        high: "Déclaration forte"
      },
      why: {
        gym: "Vous commencez par l’entraînement, donc partez sur des pièces conçues pour le mouvement, le confort et la durabilité - puis choisissez le style qui vous parle dans la collection.",
        pro: "Vous recherchez un look de performance avec de la présence. Commencez par des styles conçus pour bouger et ressortir dans les contextes les plus énergiques.",
        fashion: "Vous portez les leggings comme une vraie partie de votre tenue. Commencez par des designs orientés style, pensés pour rester nets au-delà du gymnase.",
        bundles: "Vous voulez une tenue coordonnée sans hésitation. Commencez par des ensembles assortis conçus pour fonctionner visuellement."
      },
      buttons: {
        shop: "Voir cette collection",
        alt: "Explorer une alternative",
        direction: "Essayer une autre direction",
        joggers: "Essayer les joggers"
      },
      footerBundle: "Vous préférez une seule pièce ? Vous pouvez parcourir les collants de catch ou les meggings de mode.",
      picksTitle: "Sélections pour votre style",
      basedOn: "D’après vos choix : énergie ",
      energyWord: ", ",
      impactWord: ".",
      picksSub: "Ces sélections équilibrent style et confort selon votre façon de bouger et d’être vu.",
      loose: "Vous préférez quelque chose de plus ample ?",
      fullOutfit: "Vous voulez une tenue complète ?",
      from: "À partir de ",
      tap: "Voir le produit",
      view: "Voir ",
      joggersFallback: "Alternative plus ample",
      bundleFallback: "Joggers et bomber",
      badges: {
        gym: "PERFORMANCE GYM",
        wrestling: "STYLE CATCH",
        meggings: "MEGGINGS MODE"
      }
    },

    es: {
      routeNames: {
        gym: "Leggings de gimnasio",
        pro: "Mallas de lucha profesional",
        fashion: "Meggings de moda",
        bundles: "Conjuntos a juego"
      },
      feelNames: {
        compression: "Compresión firme",
        balanced: "Ajuste equilibrado",
        relaxed: "Sensación más relajada"
      },
      energyNames: {
        classic: "Clásico y atrevido",
        neon: "Neón y expresivo",
        retro: "Retro 80s",
        dark: "Oscuro y gráfico",
        clean: "Limpio y minimal"
      },
      boldNames: {
        low: "Discreto",
        mid: "Visible",
        high: "Muy llamativo"
      },
      why: {
        gym: "Tu prioridad es entrenar, así que empieza con piezas creadas para movimiento, comodidad y durabilidad - luego elige el look que encaje contigo dentro de la colección.",
        pro: "Quieres un look de rendimiento con presencia. Empieza con estilos diseñados para moverse bien y destacar en contextos de alta energía.",
        fashion: "Estás usando leggings como parte del outfit. Empieza con diseños centrados en el estilo, pensados para verse bien más allá del gimnasio.",
        bundles: "Quieres un conjunto coordinado sin complicarte. Empieza con sets a juego diseñados para funcionar visualmente."
      },
      buttons: {
        shop: "Ver esta colección",
        alt: "Explorar una alternativa",
        direction: "Probar otra dirección",
        joggers: "Probar joggers"
      },
      footerBundle: "¿Prefieres una sola prenda? Puedes ver las mallas de lucha profesional o los meggings de moda.",
      picksTitle: "Selecciones para tu estilo",
      basedOn: "Según tus elecciones: energía ",
      energyWord: ", ",
      impactWord: ".",
      picksSub: "Estas selecciones equilibran estilo y comodidad según cómo quieres moverte y ser visto.",
      loose: "¿Prefieres algo más suelto?",
      fullOutfit: "¿Quieres un conjunto completo?",
      from: "Desde ",
      tap: "Ver producto",
      view: "Ver ",
      joggersFallback: "Alternativa más holgada",
      bundleFallback: "Joggers y chaqueta bomber",
      badges: {
        gym: "RENDIMIENTO GYM",
        wrestling: "ESTILO LUCHA",
        meggings: "MEGGINGS DE MODA"
      }
    },

    de: {
      routeNames: {
        gym: "Gym-Leggings",
        pro: "Pro-Wrestling-Tights",
        fashion: "Fashion-Meggings",
        bundles: "Passende Sets"
      },
      feelNames: {
        compression: "Feste Kompression",
        balanced: "Ausgewogene Passform",
        relaxed: "Entspannteres Gefühl"
      },
      energyNames: {
        classic: "Klassisch und mutig",
        neon: "Neon und expressiv",
        retro: "Retro 80s",
        dark: "Dunkel und grafisch",
        clean: "Klar und minimal"
      },
      boldNames: {
        low: "Zurückhaltend",
        mid: "Auffällig",
        high: "Statement"
      },
      why: {
        gym: "Bei dir steht Training zuerst, also starte mit Teilen, die für Bewegung, Komfort und Haltbarkeit gemacht sind - danach wählst du den Look innerhalb der Kollektion.",
        pro: "Du willst einen Performance-Look mit Präsenz. Starte mit Styles, die sich gut bewegen und in energiegeladenen Situationen auffallen.",
        fashion: "Du trägst Leggings als Teil deines Outfits. Starte mit styling-orientierten Designs, die auch außerhalb des Gyms stark aussehen.",
        bundles: "Du willst ein abgestimmtes Outfit ohne Rätselraten. Starte mit passenden Sets, die visuell zusammen funktionieren."
      },
      buttons: {
        shop: "Diese Kollektion ansehen",
        alt: "Alternative entdecken",
        direction: "Andere Richtung testen",
        joggers: "Joggers testen"
      },
      footerBundle: "Du bevorzugst ein einzelnes Teil? Du kannst Pro-Wrestling-Tights oder Fashion-Meggings ansehen.",
      picksTitle: "Top-Auswahl für deinen Stil",
      basedOn: "Basierend auf deiner Auswahl: ",
      energyWord: " Energie, ",
      impactWord: ".",
      picksSub: "Diese Auswahl verbindet Stil und Komfort danach, wie du dich bewegen und sichtbar sein willst.",
      loose: "Lieber etwas lockerer?",
      fullOutfit: "Willst du ein komplettes Outfit?",
      from: "Ab ",
      tap: "Produkt ansehen",
      view: "Ansehen: ",
      joggersFallback: "Lockerere Alternative",
      bundleFallback: "Joggers und Bomberjacke",
      badges: {
        gym: "GYM-PERFORMANCE",
        wrestling: "PRO-WRESTLING-STIL",
        meggings: "FASHION-MEGGINGS"
      }
    }
  };

  var T = I18N[LANG] || I18N.en;

  var URLS = {
    pro: bpLocalizePath("/collections/mens-pro-wrestling-tights"),
    gym: bpLocalizePath("/collections/mens-gym-leggings"),
    fashion: bpLocalizePath("/collections/mens-fashion-meggings"),
    bundles: bpLocalizePath("/collections/wrestling-cosplay-bundles-for-men"),
    joggers: bpLocalizePath("/collections/mens-joggers")
  };

  /* =========================================
    Pick intensity (1=subtle, 2=mid, 3=statement)
  ========================================== */

  var PICK_INTENSITY = {
    "mens-leggings-jiujitsu-spats": 1,
    "mens-leggings-bjj-compression-spats": 1,
    "mens-leggings-tiger-sports": 2,
    "mens-leggings-hollywood-lightning": 2,
    "mens-leggings-celestia": 2,
    "mens-leggings-cyberpunk": 3,
    "mens-leggings-geometric-glitchcore": 3,
    "mens-leggings-futuristic-geometric": 3,
    "mens-leggings-geometric-color-splash": 3,
    "mens-leggings-galactic-nebula": 3,

    "mens-leggings-military-eagle": 1,
    "mens-leggings-circus": 2,
    "mens-leggings-villain-wrestler": 3,
    "wrestling-tights-red-leopard-skin": 3,

    "patterned-mens-leggings-triangular-puzzle": 2,
    "mens-leggings-watermelon": 3,
    "mens-leggings-steampunk-horology": 2,
    "mens-leggings-memphis-harajuku": 3
  };

  var JOGGER_PICKS = {
    gym: [
      "patterned-mens-joggers-blue-geometric-rhythm",
      "patterned-mens-joggers-bird-flight",
      "patterned-mens-joggers-silver-memphis"
    ],
    fashion: [
      "patterned-mens-joggers-russian-mid-century",
      "patterned-mens-joggers-raspberry-teal-leopard-skin",
      "patterned-mens-joggers-multicoloured-geometric-circus",
      "mens-joggers-memphis-harajuku"
    ],
    pro: [
      "mens-joggers-eagle-star",
      "mens-joggers-macho-fire",
      "mens-joggers-wrestling-superhero"
    ],
    bundles: {
      gym: [],
      fashion: [],
      pro: ["wrestling-cosplay-joggers-bomber-jacket-eagle-star"]
    }
  };

  var form = document.getElementById("bpFinderForm");
  if(!form) return;

  var btnGo = document.getElementById("bpFinderGo");
  var btnReset = document.getElementById("bpFinderReset");

  var result = document.getElementById("bpFinderResult");
  var title = document.getElementById("bpFinderTitle");
  var why = document.getElementById("bpFinderWhy");
  var primary = document.getElementById("bpFinderPrimaryLink");
  var alt1 = document.getElementById("bpFinderAlt1");
  var alt2 = document.getElementById("bpFinderAlt2");
  var footerNote = document.getElementById("bpFinderFooterNote");

  var picksWrap = document.getElementById("bpFinderPicks");
  var picksGrid = document.getElementById("bpFinderPicksGrid");

  function getVal(name){
    var el = form.querySelector('input[name="'+name+'"]:checked');
    return el ? el.value : "";
  }

  function makeLabel(use, feel, energy, bold){
    var useKey = use === "bundle" ? "bundles" : use;

    return [
      T.routeNames[useKey] || T.routeNames.gym,
      T.feelNames[feel] || T.feelNames.balanced,
      T.energyNames[energy] || T.energyNames.classic,
      T.boldNames[bold] || T.boldNames.mid
    ].join(" - ");
  }

  function rankRoutes(use, feel, bold){
    var score = { gym: 0, pro: 0, fashion: 0, bundles: 0 };
    var useKey = (use === "bundle") ? "bundles" : use;

    score[useKey] += 100;

    if(feel === "compression"){ score.pro += 12; score.gym += 6; }
    if(feel === "balanced"){ score.gym += 10; score.pro += 4; score.fashion += 4; }
    if(feel === "relaxed"){ score.fashion += 12; score.gym += 5; }

    if(bold === "high"){ score.pro += 10; score.fashion += 10; score.gym += 2; }
    if(bold === "mid"){ score.gym += 6; score.pro += 6; score.fashion += 6; }
    if(bold === "low"){ score.gym += 10; score.fashion += 4; score.pro += 4; }

    if(use !== "bundle"){ score.bundles += 1; }

    var keys = Object.keys(score);
    keys.sort(function(a,b){ return score[b] - score[a]; });
    return keys;
  }

  function setLink(el, key, text){
    if(!el) return;
    el.href = URLS[key] || "#";
    el.textContent = text;
  }

  function cleanHandles(arr){
    if(!arr || !arr.length) return [];
    return arr
      .filter(function(h){
        return typeof h === "string" && h.length > 0 && h.indexOf("<") === -1 && h.indexOf(">") === -1;
      })
      .slice(0, 4);
  }

  function routeMatchesProduct(primaryKey, p){
    var tags = (p && p.tags ? p.tags : []).map(function(t){
      return String(t).toLowerCase();
    });

    if(primaryKey === "gym"){
      return tags.some(function(t){ return t.indexOf("gym") !== -1; });
    }

    if(primaryKey === "pro"){
      return tags.some(function(t){ return t.indexOf("wrestling") !== -1; });
    }

    if(primaryKey === "fashion"){
      return tags.some(function(t){ return t.indexOf("meggings") !== -1; });
    }

    if(primaryKey === "bundles"){
      return true;
    }

    return false;
  }

  function sortProductsByRouteMatch(primaryKey, products){
    return (products || []).slice().sort(function(a, b){
      var aMatch = routeMatchesProduct(primaryKey, a) ? 1 : 0;
      var bMatch = routeMatchesProduct(primaryKey, b) ? 1 : 0;
      return bMatch - aMatch;
    });
  }

  function sortHandlesByBoldness(handles, bold){
    var target =
      bold === "low" ? 1 :
      bold === "mid" ? 2 :
      3;

    return handles
      .map(function(h, idx){
        var intensity = PICK_INTENSITY[h] || 2;
        return { h: h, idx: idx, intensity: intensity };
      })
      .sort(function(a,b){
        var da = Math.abs(a.intensity - target);
        var db = Math.abs(b.intensity - target);
        if(da !== db) return da - db;
        return a.idx - b.idx;
      })
      .map(function(x){ return x.h; });
  }

function moneyFromCents(cents){
  try{
    var amount = Number(cents) / 100;

    var activeCurrency = "GBP";

    if(window.Shopify && Shopify.currency && Shopify.currency.active){
      activeCurrency = Shopify.currency.active;
    }

    return new Intl.NumberFormat(document.documentElement.lang || undefined, {
      style: "currency",
      currency: activeCurrency,
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }).format(amount);

  }catch(e){
    var fallback = (Number(cents) / 100).toFixed(2);
    return "£" + fallback;
  }
}

  function fetchProduct(handle){
    var localizedUrl = bpLocalizePath("/products/" + handle + ".js");
    var defaultUrl = "/products/" + handle + ".js";

    return fetch(localizedUrl, { credentials: "same-origin" })
      .then(function(r){
        if(!r.ok && localizedUrl !== defaultUrl){
          return fetch(defaultUrl, { credentials: "same-origin" });
        }
        return r;
      })
      .then(function(r){
        if(!r.ok) throw new Error("Fetch failed for " + handle);
        return r.json();
      })
      .then(function(product){
        product.tags = product.tags || [];
        return product;
      });
  }

  function getPickList(routeKey, energy, bold, feel){
    if(typeof TOP_PICKS_V2 === "undefined"){
      return [];
    }

    var route = TOP_PICKS_V2[routeKey];
    if(!route) return [];

    var bucket = route[energy];

    if(!bucket){
      if(route.classic){
        bucket = route.classic;
      }else{
        var keys = Object.keys(route);
        if(keys && keys.length){
          bucket = route[keys[0]];
        }
      }
    }

    if(!bucket) return [];

    var feelOrder = [feel, "balanced", "compression", "relaxed"];

    for(var i = 0; i < feelOrder.length; i++){
      var f = feelOrder[i];
      if(bucket[f] && bucket[f][bold] && bucket[f][bold].length){
        return bucket[f][bold];
      }
    }

    if(bucket.base && bucket.base.length){
      return bucket.base;
    }

    return [];
  }

  function getRouteLabel(p, primaryKey){
    var tags = (p && p.tags ? p.tags : []).map(function(t){
      return String(t).toLowerCase();
    });

    var hasGym = tags.some(function(t){ return t.indexOf("gym") !== -1; });
    var hasWrestling = tags.some(function(t){ return t.indexOf("wrestling") !== -1; });
    var hasMeggings = tags.some(function(t){ return t.indexOf("meggings") !== -1; });

    if(primaryKey === "gym" && hasGym){
      return { text: T.badges.gym, cls: "gym" };
    }

    if(primaryKey === "pro" && hasWrestling){
      return { text: T.badges.wrestling, cls: "wrestling" };
    }

    if(primaryKey === "fashion" && hasMeggings){
      return { text: T.badges.meggings, cls: "meggings" };
    }

    if(hasWrestling){
      return { text: T.badges.wrestling, cls: "wrestling" };
    }

    if(hasMeggings){
      return { text: T.badges.meggings, cls: "meggings" };
    }

    if(hasGym){
      return { text: T.badges.gym, cls: "gym" };
    }

    return null;
  }

  function buildRouteLabelHtml(p, primaryKey){
    var route = getRouteLabel(p, primaryKey);
    if(!route) return "";
    return '<div class="bp-finder-route-label ' + route.cls + '">' + route.text + '</div>';
  }

  function productHref(p){
    if(!p) return "#";
    return bpLocalizePath(p.url || ("/products/" + p.handle));
  }

  function renderPickCard(p, context, fallbackMeta){
    var img = p.featured_image || (p.images && p.images[0]) || "";
    var price = (p.price != null) ? moneyFromCents(p.price) : "";

    var a = document.createElement("a");
    a.className = "bp-finder-pick";
    a.href = productHref(p);
    a.setAttribute("aria-label", T.view + (p.title || "Product"));

    attachFinderTracking(a, p, context);

    var imageHtml = img
      ? '<img src="'+ img +'" alt="'+ (p.title || "Pick") +'">'
      : '<div style="width:64px;height:64px;border-radius:12px;background:rgba(255,255,255,0.06);"></div>';

    var routeHtml = buildRouteLabelHtml(p, context.route);

    a.innerHTML =
      imageHtml +
      '<div>' +
        routeHtml +
        '<p class="bp-finder-pick-title">'+ (p.title || "Pick") +'</p>' +
        '<p class="bp-finder-pick-meta">'+ (price ? (T.from + price) : fallbackMeta) +'</p>' +
      '</div>';

    return a;
  }

  function renderPicks(primaryKey, energy, bold, feel){
    if(!picksWrap || !picksGrid) return;

    picksGrid.innerHTML = "";
    picksWrap.style.display = "none";

    var intro = document.createElement("div");
    intro.className = "bp-finder-intro";

    intro.textContent =
      T.basedOn +
      (T.energyNames[energy] || T.energyNames.classic).toLowerCase() +
      T.energyWord +
      (T.feelNames[feel] || T.feelNames.balanced).toLowerCase() +
      ", " +
      (T.boldNames[bold] || T.boldNames.mid).toLowerCase() +
      T.impactWord;

    var sub = document.createElement("div");
    sub.className = "bp-finder-intro-sub";
    sub.textContent = T.picksSub;

    picksGrid.appendChild(intro);
    picksGrid.appendChild(sub);

    var joggerKey = (primaryKey === "bundles") ? "pro" : primaryKey;

    var list = getPickList(primaryKey, energy, bold, feel);
    var handles = cleanHandles(list);

    function renderJoggers(){
      return new Promise(function(resolve){
        if(!(feel === "relaxed" && JOGGER_PICKS && JOGGER_PICKS[joggerKey] && JOGGER_PICKS[joggerKey].length)){
          return resolve(false);
        }

        picksWrap.style.display = "block";

        var note = document.createElement("div");
        note.className = "bp-finder-picks-sep";
        note.textContent = T.loose;
        picksGrid.appendChild(note);

        var joggerHandles = cleanHandles(JOGGER_PICKS[joggerKey]).slice(0, 2);

        Promise.allSettled(joggerHandles.map(fetchProduct))
          .then(function(results){
            var joggers = results
              .filter(function(r){ return r.status === "fulfilled" && r.value; })
              .map(function(r){ return r.value; });

            if(!joggers.length){
              if(note && note.parentNode) note.parentNode.removeChild(note);
              if(!picksGrid.children.length) picksWrap.style.display = "none";
              return resolve(false);
            }

            joggers.forEach(function(p, i){
              picksGrid.appendChild(renderPickCard(p, {
                route: primaryKey,
                energy: energy,
                feel: feel,
                bold: bold,
                kind: "jogger",
                slot: (typeof i === "number" ? (i + 1) : 0),
                target_collection: URLS.joggers
              }, T.joggersFallback));
            });

            if(JOGGER_PICKS.bundles && JOGGER_PICKS.bundles[joggerKey] && JOGGER_PICKS.bundles[joggerKey].length){
              var bundleHandle = JOGGER_PICKS.bundles[joggerKey][0];
              if(!bundleHandle) return resolve(true);

              fetchProduct(bundleHandle)
                .then(function(p){
                  var note2 = document.createElement("div");
                  note2.className = "bp-finder-picks-sep";
                  note2.textContent = T.fullOutfit;
                  picksGrid.appendChild(note2);

                  picksGrid.appendChild(renderPickCard(p, {
                    route: "bundles",
                    energy: energy,
                    feel: feel,
                    bold: bold,
                    kind: "bundle_addon",
                    slot: 1,
                    target_collection: URLS.bundles
                  }, T.bundleFallback));

                  picksWrap.style.display = picksGrid.children.length ? "block" : "none";
                  resolve(true);
                })
                .catch(function(){
                  picksWrap.style.display = picksGrid.children.length ? "block" : "none";
                  resolve(true);
                });
            }else{
              picksWrap.style.display = picksGrid.children.length ? "block" : "none";
              resolve(true);
            }
          })
          .catch(function(){
            if(note && note.parentNode) note.parentNode.removeChild(note);
            if(!picksGrid.children.length) picksWrap.style.display = "none";
            resolve(false);
          });
      });
    }

    if(handles.length){
      handles = sortHandlesByBoldness(handles, bold);

      Promise.allSettled(handles.map(fetchProduct))
        .then(function(results){
          var products = results
            .filter(function(r){ return r.status === "fulfilled" && r.value; })
            .map(function(r){ return r.value; });

          products = sortProductsByRouteMatch(primaryKey, products);

          var anyMain = false;

          if(products && products.length){
            products.forEach(function(p, i){
              if(!p) return;
              anyMain = true;

              picksGrid.appendChild(renderPickCard(p, {
                route: primaryKey,
                energy: energy,
                feel: feel,
                bold: bold,
                kind: "main",
                slot: (typeof i === "number" ? (i + 1) : 0),
                target_collection: URLS[primaryKey] || ""
              }, T.tap));
            });
          }

          if(anyMain){
            picksWrap.style.display = "block";
          }

          return renderJoggers();
        })
        .then(function(){
          picksWrap.style.display = picksGrid.children.length ? "block" : "none";
        })
        .catch(function(){
          renderJoggers().then(function(){
            picksWrap.style.display = picksGrid.children.length ? "block" : "none";
          });
        });
    }else{
      renderJoggers().then(function(){
        picksWrap.style.display = picksGrid.children.length ? "block" : "none";
        if(!picksGrid.children.length){
          picksGrid.innerHTML = "";
        }
      });
    }
  }

  function show(){
    var use = getVal("use");
    var feel = getVal("feel");
    var energy = getVal("energy");
    var bold = getVal("bold");

    var ranked = rankRoutes(use, feel, bold);
    var primaryKey = ranked[0];
    var altAKey = ranked[1];
    var altBKey = ranked[2];

    bpFinderTrack("bp_finder_route_selected", {
      route: primaryKey,
      energy: energy,
      feel: feel,
      bold: bold,
      target_collection: URLS[primaryKey] || null
    });

    if(feel === "relaxed"){
      altBKey = "joggers";
    }

    title.textContent = makeLabel(use, feel, energy, bold);
    why.textContent = T.why[primaryKey] || T.why.gym;

    setLink(primary, primaryKey, T.buttons.shop);
    setLink(alt1, altAKey, T.buttons.alt);

    if(altBKey === "joggers"){
      setLink(alt2, "joggers", T.buttons.joggers);
    }else{
      setLink(alt2, altBKey, T.buttons.direction);
    }

    footerNote.textContent =
      (use === "bundle" || primaryKey === "bundles")
        ? T.footerBundle
        : "";

    renderPicks(primaryKey, energy, bold, feel);

    result.classList.add("is-visible");

    bpFinderTrack("bp_finder_results_shown", {
      route: primaryKey,
      energy: energy,
      feel: feel,
      bold: bold,
      target_collection: URLS[primaryKey] || null
    });

    result.scrollIntoView({ behavior: "smooth", block: "start" });
  }

  function reset(){
    form.reset();
    result.classList.remove("is-visible");

    if(picksWrap && picksGrid){
      picksGrid.innerHTML = "";
      picksWrap.style.display = "none";
    }
  }

  if(btnGo){
    btnGo.addEventListener("click", show);
  }

  if(btnReset){
    btnReset.addEventListener("click", reset);
  }

  function bpFinderTrack(eventName, params){
    try{
      params = params || {};

      if(window.dataLayer && typeof window.dataLayer.push === "function"){
        window.dataLayer.push(Object.assign({ event: eventName }, params));
        return true;
      }

      if(typeof window.gtag === "function"){
        window.gtag("event", eventName, params);
        return true;
      }

      try{
        window.dispatchEvent(new CustomEvent("bp:finder", {
          detail: Object.assign({ name: eventName }, params)
        }));
      }catch(e){}

      return true;
    }catch(e){
      return false;
    }
  }

  function trackFinderClick(data){
    try{
      document.dispatchEvent(new CustomEvent("bp_finder_click", { detail: data }));
    }catch(e){}

    bpFinderTrack("bp_finder_pick_click", data || {});
  }

  function attachFinderTracking(a, p, context){
    if(!a || !p) return;

    context = context || {};

    a.addEventListener("click", function(){
      trackFinderClick({
        route: context.route || "",
        energy: context.energy || "",
        feel: context.feel || "",
        bold: context.bold || "",
        kind: context.kind || "",
        slot: context.slot || 0,
        handle: p.handle || "",
        target_collection: context.target_collection || ""
      });
    });
  }
})();